import { CommunicationPreview } from '@all-manager/design-system-v2';
import type { ActivityTimelineFeed } from '../../../../../types';
import { useActivityTimelineCommunicationPreview } from './useActivityTimelineCommunicationPreview';

type Props = {
  item: ActivityTimelineFeed;
};

export default function ActivityTimelineCommunicationPreview(props: Props) {
  const hook = useActivityTimelineCommunicationPreview(props);

  return <CommunicationPreview item={hook.communication} documents={hook.documents} />;
}
